export default {
  messages: {
    protocolItem: {
      create: 'Dodaj pozycję protokołu',
      update: 'Edytuj pozycję protokołu',
      module: {
        name: 'Pozycje protokołu'
      },
      entity: {
        id: 'Id',
        protocol: 'Protokół',
        contractItem: 'Pozycja umowy',
        donePercent: 'Wykonano',
        cost: 'Koszt',
        description: 'Opis',
        notes: 'Uwagi',
        createdBy: 'Dodany przez',
        updatedBy: 'Modyfikowany przez',
        createdAt: 'Data dodania',
        updatedAt: 'Ostatnia modyfikacja'
      },
      grid: [],
      actions: {
        create: 'Dodaj',
        update: 'Edytuj',
        delete: 'Usuń'
      }
    }
  }
};
